<script>
import { mapActions } from "vuex";
import PrefectureList from "@/mixins/PrefectureList";
import InfiniteEmissionAndLocationAutoComplete from "../../../../components/InfiniteEmissionAndLocationAutoComplete.vue";
import InfiniteTraderAndLocationAutoComplete from "@/driver/components/InfiniteTraderAndLocationAutoComplete.vue";
import SearchEmissionDialog from "@/driver/pages/dialogs/_SearchEmissionDialog.vue";
import SearchTraderDialog from "@/driver/pages/dialogs/_SearchTraderDialog.vue";

export default {
  name: 'DuplicateManifestDialog',
  components: {
    SearchTraderDialog,
    SearchEmissionDialog,
    InfiniteTraderAndLocationAutoComplete,
    InfiniteEmissionAndLocationAutoComplete
  },
  mixins: [
    PrefectureList
  ],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestLevel: {
      type: String,
      default: () => 'first_manifest',
    },
    voteStaffs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      selectedRow: null,
      conditions: {
        supplier_id: null,
        supplier_type: "Emission",
        supplier_location_id: null,
        supplier_location_code: null,
        supplier_trader_id: null,
        supplier_trader_type: "Trader",
        supplier_trader_location_id: null,
        supplier_trader_location_code: null,
        vote_staff: null,
        keyword: null,
        start_date: null,
        end_date: null,
        waste_name: null,
        manifest_search_keyword: null,
      },
      selectedManifestId: null,
      tableHeaders: [
        { text: '引渡し日', value: 'collected_date', },
        { text: '回収先', value: 'emission', },
        { text: 'DXEマニ番号\r\n受注番号', value: 'order_no',},
        { text: 'マニフェスト番号', value: 'manifest_no', },
        { text: '品目/荷姿/数量', value: 'waste', },
      ],
      manifests: [],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      snackbar: false,
      message: null,
      timeout: 5000,
      showEmissionModal: false,
      showTraderModal: false,
    }
  },
  computed: {
  },
  watch: {
    enableDialog () {
      this.manifests = []
      this.page = 1
      this.pagination = {current_page: 1,total_count: 0}
      this.selectedRow = null
      this.selectedManifestId = null
      Object.assign(this.$data.conditions, this.$options.data().conditions)
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverDuplicateManifest', {
      fetchDuplicateManifests: 'index',
    }),
    ...mapActions('DriverMasterSearchJipCode', {
      fetchJipCode: 'show'
    }),
    /**
     * 回収先を選択（排出事業者）ボタン クリックイベント
     */
    showEmissionModalButtonClickEvent () {
      this.showEmissionModal = true
    },
    /**
     * 回収先を選択（収運・処分事業者）ボタン クリックイベント
     */
    showTraderModalButtonClickEvent() {
      this.showTraderModal = true;
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.selectedManifestId = null
      if (this.selectedRow) {
        this.selectedRow.select(false)
        this.selectedRow = null
      }
      this.page = 1
      this.searchManifests()
    },
    /**
     * テーブル行 クリックイベント
     * @param item
     * @param row
     */
    rowClickEvent (item, row) {
      this.selectedManifestId = item.id
      this.selectedRow = row
      row.select(true);
    },
    /**
     * テーブル行 ダブルクリックイベント
     * @param $event
     * @param row
     */
    rowDoubleClickEvent ($event, row) {
      this.selectedManifestId = row.item.id
      this.selectedRow = row
      row.select(true);
      this.registerButtonClickEvent();
    },
    /**
     * ページボタン クリックイベント
     */
    pageChangeEvent () {
      this.searchManifests()
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 複写して作成ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let params = this.buildCheckParam()
      this.fetchJipCode({ params: params }).then((content) => {
        if (content.message) {
          this.message = content.message
          this.snackbar = true
        } else {
          this.$emit('registerEvent', this.selectedManifestId)
        }
      })
    },

    /**
     * モーダルフラグを落とす
     */
    closeDialog () {
      this.showEmissionModal = false;
      this.showTraderModal = false;
    },
    /**
     * 検索処理
     */
    searchManifests () {
      if (!this.enableDialog) return false;
      let params = {
        ...this.conditions,
        search_type: 'duplicate',
        type_of_manifest: this.manifestLevel,
        page: this.page,
      }
      this.fetchDuplicateManifests({ conditions: params }).then((content) => {
        this.manifests = content.manifests
        this.pagination = content.pagination
      })
    },
    /**
     * 回収先（排出事業者・事業場） チェンジコールバック
     *
     * @param emission_id { Number } 排出事業者ID
     * @param location_id { Number } 排出事業場ID
     * @param location_code { String } 排出事業場コード
     */
    supplierChangeCallback (emission_id, location_id, location_code) {
      let changed = false;
      if (this.conditions.supplier_id !== emission_id) {
        changed = true;
      }

      if (this.conditions.supplier_location_id !== location_id) {
        changed = true;
      }

      this.conditions.supplier_id = emission_id;
      this.conditions.supplier_location_id = location_id;
      this.conditions.supplier_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 排出事業者選択モーダル　コールバック
     * @param item
     */
    choseSupplierCallback(item) {
      this.conditions.supplier_id = item.id;
      this.conditions.supplier_type = "Emission";
      this.conditions.supplier_location_id = item.location?.id;
      this.conditions.supplier_location_code = item.location?.code;
      this.conditions.supplier_type = item.type;
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();
    },
    /**
     * 回収先 収運・処分事業者チェンジ コールバック
     */
    supplierTraderChangedCallback (trader_id, location_id, location_code) {

      let changed = false;

      if (this.conditions.supplier_trader_id !== trader_id) {
        changed = true;
      }

      if (this.conditions.supplier_trader_location_id !== location_id) {
        changed = true;
      }

      this.conditions.supplier_trader_id = trader_id;
      this.conditions.supplier_trader_type = "Trader"
      this.conditions.supplier_trader_location_id = location_id;
      this.conditions.supplier_trader_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); });
      }
    },
    /**
     * 収運・処分業者選択モーダル コールバック
     * @param item
     */
    choseTransportCallback(item) {
      this.conditions.supplier_trader_id = item.id;
      this.conditions.supplier_trader_type = "Trader"
      this.conditions.supplier_trader_location_id = item.location.id;
      this.conditions.supplier_trader_location_code = item.location.code;
      this.$nextTick(() => { this.handleSearch(); });
      this.closeDialog();
    },
    startDateChangedCallback (date) {
      this.conditions.start_date = date;
      this.handleSearch()
    },
    endDateChangedCallback (date) {
      this.conditions.end_date = date;
      this.handleSearch()
    },
    buildCheckParam() {
      return {
        zip_code: this.selectedRow.item.emission.zip_code,
        prefecture_code: this.selectedRow.item.emission.prefecture_code,
        address_1: this.selectedRow.item.emission.address_1,
        location_zip_code: this.selectedRow.item.emission_location.zip_code,
        location_prefecture_code: this.selectedRow.item.emission_location.prefecture_code,
        location_address_1: this.selectedRow.item.emission_location.address_1,
      }
    },
    handleSearch () {
      this.searchButtonClickEvent();
    },
    /**
     * 各種クリアボタン クリックイベント
     * @param keys { String, Array } プロパティ名
     */
    clearEvent (keys) {
      if (Array.isArray(keys)) {
        keys.forEach(key => this.conditions[key] = null);
      } else {
        this.conditions[keys] = null;
      }
      this.handleSearch();
    },
  }
}
</script>
<template>
  <v-dialog
    :value="enableDialog"
    persistent
    scrollable
    width="1200"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>複写するマニフェストを選択</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <!-- 検索ブロック -->
        <v-card flat>
          <v-card-text>

            <!-- 回収先（排出事業者） -->
            <infinite-emission-and-location-auto-complete
              :supplier-id="conditions.supplier_id"
              :location-id="conditions.supplier_location_id"
              :location-code="conditions.supplier_location_code"
              :without-invisible="true"
              supplier-label="回収先（排出事業者）"
              location-label="回収先事業場"
              supplier-md="6"
              location-md="6"
              classes="search-font"
              only-valid-location
              rounded
              @update:values="supplierChangeCallback"
            >
              <template v-slot:supplier-append-outer>
                <v-btn
                  class="primary"
                  small
                  @click="showEmissionModalButtonClickEvent"
                >
                  回収先を選択
                </v-btn>
                <search-emission-dialog
                  :enable-dialog="showEmissionModal"
                  emission-filter="exclude_general"
                  @cancelCallback="closeDialog"
                  @registerCallback="choseSupplierCallback"
                />
              </template>
            </infinite-emission-and-location-auto-complete>
            <!-- /回収先（排出事業者） -->

            <!-- 回収先（収運・処分事業者）, 収運業者 -->
            <infinite-trader-and-location-auto-complete
              :trader-id="conditions.supplier_trader_id"
              :location-id="conditions.supplier_trader_location_id"
              :location-code="conditions.supplier_trader_location_code"
              trader-label="回収先（収運・処分事業者）"
              location-label="回収先事業者"
              trader-md="6"
              location-md="6"
              classes="search-font"
              rounded
              search-type="either"
              only-transship
              without-none-reporting
              without-none-subscribe
              :without-invisible="true"
              @update:values="supplierTraderChangedCallback"
            >
              <template v-slot:trader-append-outer>
                <v-btn
                  color="primary"
                  small
                  @click="showTraderModalButtonClickEvent"
                >
                  回収先を選択
                </v-btn>
                <search-trader-dialog
                  :enable-dialog="showTraderModal"
                  @cancelCallback="closeDialog"
                  @registerCallback="choseTransportCallback"
                />
              </template>
            </infinite-trader-and-location-auto-complete>
            <!-- /回収先（収運・処分事業者）, 収運業者 -->

            <!-- 引渡日, 終了日, DXE起票担当者 -->
            <v-row>
              <v-col cols="12" md="4">
                <cs-date-picker
                  :date.sync="conditions.start_date"
                  @dateChangedCallback="startDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <v-text-field
                      v-model="conditions.start_date"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      class="search-font"
                      clearable
                      dense
                      hide-details="auto"
                      label="引渡し日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                      rounded
                      @click:clear="clearEvent('start_date')"
                    >
                      <template v-slot:append-outer>
                        <div
                          v-if="$vuetify.breakpoint.mdAndUp"
                          style="vertical-align: middle"
                        >
                          〜
                        </div>
                      </template>
                    </v-text-field>
                  </template>
                </cs-date-picker>
              </v-col>
              <v-col cols="12" md="4">
                <cs-date-picker
                  :date.sync="conditions.end_date"
                  @dateChangedCallback="endDateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <v-text-field
                      v-model="conditions.end_date"
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      class="search-font"
                      clearable
                      dense
                      hide-details="auto"
                      label="終了日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                      rounded
                      @click:clear="clearEvent('end_date')"
                    >
                    </v-text-field>
                  </template>
                </cs-date-picker>
              </v-col>
              <v-col cols="12" md="4">
                <v-combobox
                  v-model="conditions.vote_staff"
                  :items="voteStaffs"
                  :return-object="false"
                  clearable
                  dense
                  label="DXE起票担当者"
                  hide-details="auto"
                  outlined
                  rounded
                  persistent-placeholder
                  style="font-size: 80%"
                  @change="handleSearch"
                  @click:clear="clearEvent('vote_staff')"
                />
              </v-col>
            </v-row>
            <!-- /引渡日, 終了日, DXE起票担当者 -->

            <!-- キーワード, 廃棄物の名称 -->
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="conditions.keyword"
                  class="search-font"
                  clearable
                  dense
                  hide-details="auto"
                  label="キーワード"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="受注番号・マニフェスト番号・DXEマニ番号で検索"
                  rounded
                  @blur="handleSearch"
                  @click:clear="clearEvent('keyword')"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="conditions.waste_name"
                  background-color="white"
                  class="search-font"
                  clearable
                  dense
                  hide-details="auto"
                  label="廃棄物の名称"
                  outlined
                  rounded
                  persistent-placeholder
                  @blur="handleSearch"
                  @click:clear="clearEvent('waste_name')"
                />
              </v-col>

            </v-row>
            <!-- /キーワード, 廃棄物の名称 -->

            <!-- マニフェスト検索キーワード -->
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="conditions.manifest_search_keyword"
                  class="search-font"
                  clearable
                  dense
                  hide-details="auto"
                  label="マニフェスト検索キーワード"
                  outlined
                  persistent-placeholder
                  persistent-hint
                  rounded
                  @blur="handleSearch"
                  @click:clear="clearEvent('manifest_search_keyword')"
                />
              </v-col>
            </v-row>
            <!-- /マニフェスト検索キーワード -->

          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="searchButtonClickEvent"
            >
              <v-icon>mdi-magnify</v-icon>&nbsp;検索
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-divider />
        <!-- /検索ブロック -->

        <!-- 一覧 -->
        <v-row dense>
          <v-col cols="12">
            <div>
              <v-input
                v-model="selectedManifestId"
                dense
                outlined
                readonly
              />
              <v-data-table
                :headers="tableHeaders"
                :items="manifests"
                :items-per-page="-1"
                fixed-header
                dense
                height="35vh"
                hide-default-footer
                single-select
                disable-sort
                @click:row="rowClickEvent"
                @dblclick:row="rowDoubleClickEvent"
              >
                <!-- 回収日 -->
                <template v-slot:[`item.collected_date`]="{ item }">
                  <span>
                    <small>
                      <span v-if="item.past_manifest" style="color:#3CBF91">●</span>{{ item.collected_date | date_format }}
                    </small>
                  </span>
                </template>
                <!-- /回収日 -->

                <!-- 回収先 -->
                <template v-slot:[`item.emission`]="{ item }">
                  <small>{{ item.emission.name }}</small>
                  <v-tooltip
                    top
                    :open-on-hover="false"
                  >
                    <template #activator="{ on }">
                      <v-btn
                        v-if="item.emission_location.address"
                        icon
                        small
                        retain-focus-on-click
                        @click="on.click"
                        @blur="on.blur"
                      >
                        <v-icon small>
                          mdi-map-marker-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <strong>{{ item.emission_location.name }}</strong>
                    <br />
                    <small
                      v-if="item.emission_location.address"
                    >
                      {{item.emission_location.address}}
                    </small>
                  </v-tooltip>
                </template>
                <!-- /回収先 -->
                <!-- DXEマニ番号/受注番号 -->
                <template v-slot:[`item.order_no`]="{item}">
                  <div>{{ item.id }}&nbsp;</div>
                  <div>{{ item.order_no || '-' }}</div>
                </template>
                <!-- マニフェスト番号 -->
                <template v-slot:[`item.manifest_no`]="{ item }">
                  <div>{{ item.manifest_no }}&nbsp;</div>
                  <small class="text--disabled">{{ item.manifest_type | manifest_type_to_label }}</small>
                </template>
                <!-- /マニフェスト番号 -->
                <!-- 品目／荷姿／数量 -->
                <template v-slot:[`item.waste`]="{ item }">
                  <div>
                    <v-chip
                      :title="item.item_name"
                      color="#F0E6D0"
                      drak
                      label
                      x-small
                    >
                      {{ item.item_name | truncate(10) }}
                    </v-chip>
                  </div>
                  <small>{{ item.packing_name }}</small>&nbsp;
                  <small>{{ item.report_transport_quantity | comma_format }}&nbsp;{{ item.report_transport_quantity_unit_name }}</small>
                </template>
                <!-- /品目／荷姿／数量 -->
                <!-- 更新日 -->
                <template v-slot:[`item.updated_at`]="{ item }">
                  {{ item.updated_at | unix_date_format }}
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
        <!-- /一覧 -->

        <v-row dense>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pagination.total_pages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="pageChangeEvent"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
          @mousedown.prevent
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          :disabled="selectedManifestId === null"
          @click="registerButtonClickEvent"
        >
          複写して作成
        </v-btn>
        <v-snackbar v-model="snackbar" color="red accent-2" :timeout="timeout">
          {{ message }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

